
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { breakpointUp } from '../utils/breakpoints';

gsap.registerPlugin(ScrollTrigger);

let current_page = document.documentElement.getAttribute('data-page');
let current_url = document.documentElement.getAttribute('data-url');

if (current_page === 'new-page') {
  const stickyImage = document.querySelector('#sticky-image .animation-scale-down');

  // Initial scale setup
  if (breakpointUp('xl')) {
    gsap.set(stickyImage, { scale: 1.2 });

  // Scale-down animation
  ScrollTrigger.create({
    trigger: "#sticky-image",
    start: "top center",
    end: "center center",
    onEnter: () => {
      gsap.to(stickyImage, {
        scale: 1
      });
    }
  });

  // Sticky behavior
  ScrollTrigger.create({
    trigger: "#sticky-image",
    start: "top 5.25%",
    end: "bottom 94.75%",
    pin: "#sticky-image"
  });
  } else {
    gsap.set(stickyImage, { scale: 1 });
  }
}
